<app-menu-toggle
  tooltip="Animate event"
  icon="event-folder"
  [active]="isAnimating"
  (click)="toggleAnimateEvent()"
>
</app-menu-toggle>
